export default __webpack_public_path__ + "static/media/PDFReport-Interior-Pg3.cc2bbd5c.png";